var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.PREVIEW.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("프리뷰")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("프리뷰의 성격")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("프리뷰는 경매에 출품된 모든 작품을 감상하고 상태를 확인할 수 있는 전시회입니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("프리뷰 관람은 경매 응찰과 관계없이 누구나 무료로 관람이 가능합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("프리뷰를 통하여, 작품의 양적 가치와 질적 가치를 새롭게 발견하실 수 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("당사의 경매는, 여러분들이 프리뷰를 통해 작품의 실물을 확인하였음을 전제로 진행합니다.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("상태검사 권유 및 보증")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("프리뷰 전시에서, 작품의 상태를 충분히 확인하신 후에 응찰하시길 권유합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("당사의 경매작품은, 별도의 보수(수리)나 처치없이, 위탁받은 작품 상태 그대로 출품합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("작품보증 시점 : 경매되는 시점을 기준으로 합니다.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("경매작품 안내")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("프리뷰 전시장에서, 작품안내를 요청하시면, 경매작품에 대한 자세한 안내를 받으실 수 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("모바일 홈페이지에서, 작품별로 물리적, 논리적 세부 정보 사항을 확인하실 수 있습니다. ")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("프리뷰 일정 및 장소")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("일정 공지 : 프리뷰 일정은 문자, SNS, 홈페이지 등을 통해 공지 됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("전시 장소 : 갤러리라온 (서울시 종로구 부암동 185-6)")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("운영 시간 : 10am ~ 6pm")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("문의 : 02-395-6987")])])])]), _c('v-divider', {
    staticClass: "grey-cb my-30 my-md-36"
  }), _c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Characteristics of Preview")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Preview is an exhibition where you can view and check the condition of all works exhibited for auction.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Anyone can watch the preview exhibition for free, regardless of whether they bid or not.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Through the preview, you can discover new quantitative and qualitative values of the work.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("The auction proceed with based on check the real objects(works) through the preview show")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Condition Inspection and Guarantee")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("We recommend that you bid after thoroughly checking the condition of the works In the preview exhibition.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Our auction works are exhibited in the condition they were entrusted with, without any additional repair or treatment.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("We ensure the conditions of the works from the point we presented items on the auction.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Information on Auction Artwork")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("If you request information about the works at the exhibition hall, you can receive detailed information")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("On the mobile homepage, you can check the physical and logical information(Description) on the each work.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Preview schedule and location")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Schedule Notice: Preview schedule will be announced through text message, SNS, website, etc.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Exhibition Location : Gallery Raon (185-6 Buam-dong, Jongno-gu, Seoul)")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Operating Hours: 10am-6pm")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Inquiries: 02-395-6987")])])])])], 1)], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }